import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=44911d38&scoped=true&lang=html&"
import script from "./topic.vue?vue&type=script&lang=js&"
export * from "./topic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44911d38",
  null
  
)

export default component.exports